import React from 'react'
import PropTypes from 'prop-types'
import SearchField from "../../../home/components/filters/SearchField"
import FilterDateRangeV2 from "../../../shared/FilterDateRangeV2"
import FilterProductType from "./FilterProductType"
import BatchesPartnerSew from "./BatchesPartnerSew"
import SelectFilterOptions from "../../../shared/SelectFilterOptions"
import { BATCH_PRIORITY,ERROR_TYPE_COMPLETE, TAGS } from '../../../../helpers/ListOptions.json'
import { Select } from 'antd'

BatchesFilters.propTypes = {
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    onChangeInput: PropTypes.func.isRequired,
    onChangeDate: PropTypes.func.isRequired,
    onChangeProductType: PropTypes.func.isRequired
}

function BatchesFilters(props) {
    const {filters, onChangeProductType, listBrand} = props
    const {level} = filters

    function _handleChangeField(field, value) {
        const {onChangeInput} = props
        if(field==='brand' || field==='batch_overtime' || field === 'tags') {
            onChangeInput(field,value)
        }else{
            onChangeInput(field, value.trim())
        }
    }

    function _handleChangeDate(field, value) {
        const {onChangeDate} = props
        const cloneFilter = Object.assign({}, props.filters)

        cloneFilter[field] = value

        if (value.from === '' || value.to === '') {
            cloneFilter[field] = null
        }

        if (typeof onChangeDate === 'function') {
            onChangeDate(cloneFilter)
        }
    }

    const getOptionOverTime = (start, end) => {
        const Options = []
        for (let i = start; i <= end; i++) {
            if(i !==0){
                const Option = {
                    name: i,
                    value: i,
                }
                if(i === -1) {
                    Options.push({name: -1.5,value: -1.5,})
                }
                Options.push(Option)
            }
        }
        return Options
    }

    const Option = Select.Option
    const disableNoBrand = !!filters.brand && filters.brand.length>0 && !filters.brand.includes('no brand')
    const disableOptionBrand = !!filters.brand && filters.brand.length>0 && filters.brand.includes('no brand')

    return (
        <div className='BatchesFilters'>
            <div className='row align-items-starts'>
                <div className='FilterNameBatch col-12 col-xl-2 mb-3'>
                    <label className="font-weight-bold d-block">Tên lô</label>
                    <SearchField
                        field='name'
                        placeholder='Tìm kiếm theo tên Lô...'
                        onChangeInput={_handleChangeField}
                    />
                </div>

                <div className='col-12 col-xl-2 mb-3'>
                    <label className="font-weight-bold d-block">Người tạo lô</label>
                    <SearchField
                        field='user_create'
                        placeholder='Tìm kiếm theo người tạo ...'
                        onChangeInput={_handleChangeField}
                    />
                </div>

                <div className='FilterLevel col-12 col-xl-2 mb-3'>
                    <SelectFilterOptions
                        defaultValue={level}
                        style={{width: '100%'}}
                        listOptions={ERROR_TYPE_COMPLETE}
                        field="error_type" label="Loại lỗi"
                        handleChange={_handleChangeField}
                    />
                </div>

                <BatchesPartnerSew onChangePartner={_handleChangeField}/>

                <div className='col-12 col-xl-2 mb-3'>
                    <label className="font-weight-bold">Ngày tạo lô</label>
                    <FilterDateRangeV2 field='created_at' onDatesChange={_handleChangeDate}/>
                </div>

                <div className='FilterLevel col-12 col-xl-2 mb-3'>
                    <SelectFilterOptions
                        defaultValue={level}
                        style={{width: '100%'}}
                        listOptions={BATCH_PRIORITY}
                        field="level" label="Độ ưu tiên"
                        handleChange={_handleChangeField}
                    />
                </div>

                <div className='col-12 col-xl-4 mb-3'>
                    <label className="font-weight-bold">Loại sản phẩm</label>
                    <FilterProductType
                        productTypes={filters.product_types}
                        onChangeProductType={onChangeProductType}
                    />
                </div>
                <div className='col-12 col-xl-2 mb-3'>
                    <label for="request_update" className="d-block w-100 font-weight-bold">Brand</label>
                    <Select
                        name='brand'
                        className='brand'
                        mode={'multiple'}
                        onChange={(value) => _handleChangeField('brand', value)}
                        value={filters.brand}
                        allowClear
                        placeholder='Chọn brand name'
                        style={{ width: '100%'}}
                    >
                        <Option disabled={disableNoBrand} value='no brand'> No brand</Option>
                        {listBrand.length && listBrand.map((i, index) => (
                            <Option disabled={disableOptionBrand} value={i.value} key={index}>{i.label}</Option>
                        ))
                        }
                    </Select>
                </div>
                <div className='col-12 col-xl-2 mb-3 filterBrand RequestSelect'>
                    <SelectFilterOptions
                        defaultValue={filters.batch_overtime||[]}
                        name='batch_overtime'
                        listOptions={getOptionOverTime(-6,6)}
                        style={{width: '100%'}}
                        field="batch_overtime" label="Thời gian item quá hạn"
                        handleChange={_handleChangeField}
                        mode='multiple'
                        showArrow
                        allowClear
                        placeholder='Chọn thời gian item quá hạn'
                    />
                </div>
                <div className='col-12 col-xl-2 mb-3'>
                    <SelectFilterOptions
                        defaultValue={[]}
                        mode="multiple"
                        listOptions={TAGS}
                        style={{ width: '100%' }}
                        field="tags" label="Tags"
                        placeholder='Chọn tag'
                        allowClear
                        handleChange={_handleChangeField}
                        isMultiple={true}
                    />
                </div>
            </div>
        </div>
    )
}

export default BatchesFilters